module.exports = __webpack_public_path__ + "img/filter.32ddb939.svg";